"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactMdeSelectionHelper_1 = require("./helpers/ReactMdeSelectionHelper");
var ReactMdeToolbar_1 = require("./ReactMdeToolbar");
var ReactMdeTextArea_1 = require("./ReactMdeTextArea");
var ReactMdePreview_1 = require("./ReactMdePreview");
var ReactMde = /** @class */ (function (_super) {
    __extends(ReactMde, _super);
    function ReactMde() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Handler for the textArea value change
         * @memberOf ReactMde
         */
        _this.handleValueChange = function (value) {
            var onChange = _this.props.onChange;
            onChange(value);
        };
        /**
         * Executes a command
         * @memberOf ReactMde
         */
        _this.handleCommand = function (command) { return __awaiter(_this, void 0, void 0, function () {
            var _a, text, onChange, newValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, text = _a.value.text, onChange = _a.onChange;
                        newValue = command.execute(text, ReactMdeSelectionHelper_1.getSelection(this.textArea));
                        if (!(newValue instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, newValue];
                    case 1:
                        newValue = _b.sent();
                        _b.label = 2;
                    case 2:
                        // This is necessary because otherwise, when the value is reset, the scroll will jump to the end
                        newValue.scrollTop = this.textArea.scrollTop;
                        onChange(newValue);
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    /**
     * Renders react-mde
     * @returns
     * @memberOf ReactMde
     */
    ReactMde.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, commands = _a.commands, textAreaProps = _a.textAreaProps, showdownOptions = _a.showdownOptions, visibility = _a.visibility;
        var mergedVisibility = __assign({}, ReactMde.defaultProps.visibility, visibility);
        return (React.createElement("div", { className: "react-mde" },
            mergedVisibility.toolbar && React.createElement(ReactMdeToolbar_1.ReactMdeToolbar, { commands: commands, onCommand: this.handleCommand }),
            mergedVisibility.textarea && React.createElement(ReactMdeTextArea_1.ReactMdeTextArea, { onChange: this.handleValueChange, value: value, textAreaProps: textAreaProps, textAreaRef: function (c) { return _this.textArea = c; } }),
            mergedVisibility.preview && React.createElement(ReactMdePreview_1.ReactMdePreview, { markdown: value ? value.text : "", previewRef: function (c) { return _this.preview = c; }, showdownOptions: showdownOptions, helpVisible: mergedVisibility.previewHelp })));
    };
    ReactMde.defaultProps = {
        visibility: {
            toolbar: true,
            textarea: true,
            preview: true,
            previewHelp: true,
        },
    };
    return ReactMde;
}(React.Component));
exports.ReactMde = ReactMde;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mde/lib/js/ReactMde.js
// module id = 1088
// module chunks = 0